module.exports = __webpack_public_path__ + "static/media/Apple Chancery-01.7266b676.svg";